import { resourceReducer } from 'redux-resource';

export default resourceReducer('quickCycles');

export const getCurrentCycle = (state, subId) => {
  const usage = state && state.resources && state.resources[subId];
  return usage;
}
